import Nullstack from 'nullstack';
export default function IconCurrencyKroneCzech({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-krone-czech",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 6v12"
  }), "   ", Nullstack.element("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), "   ", Nullstack.element("path", {
    d: "M19 6l-2 2l-2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M19 12h-2a3 3 0 0 0 0 6h2"
  }), " ");
}